import $ from "jquery";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, formValueSelector, change } from "redux-form";
import Loading from "../../../components/Loading";
import { Row, Column } from "react-foundation";
import ChipsGrid from "../../../components/ChipsGrid";
import utils from "utils";
import { getMainDoorColours } from "./../../../selectors";
import ImageResolver from "./../../ImageResolver";
import { addPreviousPreviews } from "./../../../actions";
import SwitchInput from "../../../components/SwitchInput";
import Popup from "../../../components/Popup";
import WhiteInteriorPopup from "../../../components/WhiteInteriorPopup";
import InputError from "../../../components/InputError";
import ThemeButton from "../../../components/ThemeButton";
import SeparatingLine from "../../../components/SeparatingLine";
import FormHeader from "../../../components/FormHeader";
import FormWrapper from "../../FormWrapper";
import { updatePreviousSelection } from '../../../actions';

class SelectColour extends Component {
    constructor(props) {
        super(props);

        this.state = {
            selectedCategory: 1
        };
    }

    render() {
        let { frames, input, addPreviousPreviews } = this.props;

        if ($.isEmptyObject(frames)) {
            return <Loading />;
        }
        let filteredFrames = utils.filterObject(
            frames,
            frame => frame.category === this.state.selectedCategory
        );

        return (
            <div>
                <Row collapseOnSmall uncollapseOnMedium>
                    <Column small={12}>
                        <span
                            className={
                                "colour-type-label" +
                                (this.state.selectedCategory === 1 ? " selected" : "")
                            }
                            onClick={() => this.setState({ selectedCategory: 1 })}
                        >
                            Standard<span>£</span>
                        </span>

                        <span
                            className={
                                "colour-type-label" +
                                (this.state.selectedCategory === 2 ? " selected" : "")
                            }
                            onClick={() => this.setState({ selectedCategory: 2 })}
                        >
                            Special<span>££</span>
                        </span>

                        <span
                            className={
                                "colour-type-label" +
                                (this.state.selectedCategory === 3 ? " selected" : "")
                            }
                            onClick={() => this.setState({ selectedCategory: 3 })}
                        >
                            Premium<span>£££</span>
                        </span>
                    </Column>
                </Row>

                <Row collapseOnSmall uncollapseOnMedium>
                    <Column>
                        <ChipsGrid
                            key={this.state.selectedCategory}
                            colours={filteredFrames}
                            selectedId={input.value}
                            onChange={val => {
                                addPreviousPreviews({ colourId: val }, [3]);
                                input.onChange(val);
                            }}
                        />
                    </Column>
                </Row>
                <InputError metas={this.props.meta} />
            </div>
        );
    }
}

class FrameForm extends Component {
    componentDidUpdate() {
        let { defaultColourId, selectedFrame, hasPreviewImages, frames, dispatch, addPreviousPreviews, previousSelection } = this.props;

        if (!selectedFrame.id && hasPreviewImages) {
            if (frames.length > 0) {


                defaultColourId = previousSelection.DoorCompositeColourId || defaultColourId;

                addPreviousPreviews({ colourId: defaultColourId }, [3]);
                dispatch(change("DoorWizard", "DoorFrameId", defaultColourId));

                if (previousSelection.DoorCompositeColourWhiteInterior)
                    dispatch(change("DoorWizard", "DoorFrameColourInterior", previousSelection.DoorCompositeColourWhiteInterior));

            }
        }
    }

    onSubmit(values) {

        if (values.DoorFrameId !== this.props.previousSelection.DoorCompositeColourId) {
            this.props.updatePreviousSelection({
                DoorCompositeHandleColour: null,
                DoorCompositeHandleType: null
            });
        }

        this.props.updatePreviousSelection({
            DoorCompositeColourId: values.DoorFrameId,
            DoorCompositeColourWhiteInterior: values.DoorFrameColourInterior
        });

        this.props.onSubmit(values);
    }

    componentWillUpdate(newProps){
        let {hasWhiteInterior, dispatch} = this.props;

        if(!newProps.hasWhiteInterior && hasWhiteInterior){
            dispatch(change("DoorWizard", "DoorFrameColourInterior", false));

        }
    }

    render() {
        return (
            <form className="FrameForm composite" onSubmit={this.props.handleSubmit(this.onSubmit.bind(this))}            >
                <FormHeader title={"Frame Colour"} subtitle={"Pick a frame to compliment or contrast your door."} />

                <SeparatingLine />

                <FormWrapper>
                    <Row collapseOnSmall uncollapseOnMedium>
                        <Column pushOnLarge={6} large={6} className="preview-container">
                            <ImageResolver
                                query={{
                                    productId: this.props.doorTypeId,
                                    styleId: 0,
                                    slabExtraId: 0,
                                    extraGroupId: 0,
                                    extraId: 0
                                }}
                                filters={{ colourId: this.props.selectedFrame.id }}
                            />
                        </Column>
                        <Column pullOnLarge={7} large={5} style={{ paddingTop: 10 }}>
                            <Field
                                name="DoorFrameId"
                                component={SelectColour}
                                frames={this.props.frames}
                                addPreviousPreviews={this.props.addPreviousPreviews}
                            />

                            <Field
                                name="DoorFrameColourInterior"
                                component={SwitchInput}
                                disabled={!this.props.hasWhiteInterior}
                            >
                                White interior frame
                                <Popup component={WhiteInteriorPopup}>
                                    <span className="info-icon">i</span>
                                </Popup>
                            </Field>
                        </Column>
                    </Row>
                </FormWrapper>

                <div className="button-panel">
                    <SeparatingLine />

                    <button className="button back" type="button" onClick={this.props.previousPage}>
                        Back
                    </button>
                    <ThemeButton className="next">Next</ThemeButton>
                </div>
            </form>
        );
    }
}

const mapStateToProps = state => {
    let valueSelector = formValueSelector("DoorWizard");
    let doorTypeId = valueSelector(state, "DoorTypeId");
    let doorFrameId = valueSelector(state, "DoorFrameId");

    let frames = getMainDoorColours(state);

    let selectedFrame = {};

    if (doorFrameId) selectedFrame = frames.filter(c => c.id === doorFrameId)[0] || {};
    let hasWhiteInterior = selectedFrame.relatedColourId !== 0;

    let selectedType = utils.getValueById(state.Door.Types, doorTypeId);

    let defaultColourId = selectedType.defaultColourId;

    if (!defaultColourId && frames.length > 0) {
        defaultColourId = frames[0].id;
    }

    return {
        frames,
        doorTypeId,
        selectedFrame,
        hasPreviewImages: state.PreviewImages.length > 0,
        hasWhiteInterior,
        defaultColourId,
        previousSelection: state.PreviousSelection
    };
};

export default connect(mapStateToProps, { addPreviousPreviews, updatePreviousSelection })(FrameForm);



// WEBPACK FOOTER //
// ./src/containers/DoorForm/composite/FrameForm.js